import { Component, inject } from '@angular/core';

import { NbCardModule, NbDialogRef } from '@nebular/theme';

import packageInfo from '../../../../package.json';

@Component({
  selector: 'ngx-support-dialog',
  templateUrl: './support-dialog.component.html',
  styleUrls: ['./support-dialog.component.scss'],
  imports: [NbCardModule],
})
export class SupportDialogComponent {
  protected dialogRef = inject<NbDialogRef<SupportDialogComponent>>(NbDialogRef);

  appVersion = packageInfo.version;
  contact_emails = ['techsupport@bia-systems.tech'];

  closePopup() {
    this.dialogRef.close();
  }
}
